import SharedPropsService from "../../SharedPropsService";
export const goBackAction = async (action, _datastore, { navigate }) => {
    const userContext = await SharedPropsService.getCgtcUserContext();
    await SharedPropsService.setCgtcUserContext({
        pan: userContext?.pan,
        phone: userContext?.phone,
        fromDate: userContext?.fromDate,
        toDate: userContext?.toDate
    });
    await SharedPropsService.setToken(undefined);
    8;
    window.location.reload();
};
